<template>
  <svg
    id="Group_Signup_icon"
    data-name="Group Signup icon"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32.001"
    viewBox="0 0 32 32.001"
  >
    <rect
      id="Rectangle_1875"
      data-name="Rectangle 1875"
      width="32"
      height="32"
      transform="translate(0 0.001)"
      fill="none"
    />
    <path
      id="Path_1093"
      data-name="Path 1093"
      d="M346-166s-13-5.714-13-18.286v-9.143s7.583-1.143,13-4.571c5.417,3.429,13,4.571,13,4.571v9.143C359-171.714,346-166,346-166Z"
      transform="translate(-330 198.001)"
      fill="#b40068"
    />
    <path
      id="Subtraction_14"
      data-name="Subtraction 14"
      d="M-2107,6591h0v-32c5.389,3.413,12.924,4.561,13,4.572v9.143a17.279,17.279,0,0,1-2.031,8.161,21.488,21.488,0,0,1-4.469,5.7A26.587,26.587,0,0,1-2107,6591Z"
      transform="translate(2123 -6558.999)"
      fill="#2d323c"
      opacity="0.149"
    />
    <g
      id="Group_5316"
      data-name="Group 5316"
      transform="translate(-6256 8375.001)"
    >
      <path
        id="Path_1959"
        data-name="Path 1959"
        d="M103.5,102.476a4.913,4.913,0,0,0-4.3-.807,4.993,4.993,0,0,0-3.7,4.867"
        transform="translate(6171.5 -8466.494)"
        fill="none"
        stroke="#fff"
        stroke-width="2.5"
      />
      <path
        id="Path_1960"
        data-name="Path 1960"
        d="M97.572,109.03a4.913,4.913,0,0,0,4.3.807,4.993,4.993,0,0,0,3.7-4.867"
        transform="translate(6171.426 -8465.013)"
        fill="none"
        stroke="#fff"
        stroke-width="2.5"
      />
    </g>
    <path
      id="Polygon_37"
      data-name="Polygon 37"
      d="M3,0,6,3.5H0Z"
      transform="translate(18 11.501)"
      fill="#fff"
    />
    <path
      id="Polygon_38"
      data-name="Polygon 38"
      d="M3,0,6,3.5H0Z"
      transform="translate(14 18.501) rotate(-180)"
      fill="#fff"
    />
  </svg>
</template>

<script>
export default {
  name: 'FeatureGroupScoring',
}
</script>
